document.addEventListener("DOMContentLoaded", function () {
  openPerfumist();
  openNativeSearch();
  initFooterPopup();

  let selectedCap = "";
  let selectedContainer = "";
  let imageGeneration = 0;
  let imageDebounceTimer = null;
  let variantChangeDebounceTimer = null;

  var hasPreloadedImages = false;
  const capOptions = [
    "Tapón", "Prise", "Plugue", "Tappo",
    "tapón", "prise", "plugue", "tappo",
    "Embellecedor", "Enjoliveur", "Embelezador", "Abbellitore",
    "embellecedor", "enjoliveur", "embelezador", "abbellitore",
    "Korek", "korek", "Bouchon", "bouchon", "Anello decorativo", "anello decorativo",
    "Embellisseur", "embellisseur"
  ];

  const containerOptions = [
    "Envase", "Récipient", "Recipiente", "Flacone",
    "envase", "récipient", "recipiente", "flacone",
    "Varilla", "Tige", "Varinha", "Bacchetta",
    "varilla", "tige", "varinha", "bacchetta",
    "Vareta", "vareta", "Bastoncino", "bastoncino",
    "Pojemnik", "pojemnik", "Flacon", "flacon",
    "Batonnet", "batonnet"
  ];

  const inputPersonalizado = document.querySelector(
    'input[value="PERSONALIZADO"], input[value="PERSONNALISER"], input[value="PERSONALIZZA"], input[value="PERSONALIZADO 50 ML"], input[value="PERSONNALISER 50 ML"], input[value="PERSONALIZZA 50 ML"], input[value="PERSONALIZADO 100 ML"], input[value="PERSONNALISER 100 ML"], input[value="PERSONALIZZA 100 ML"], input[value="PERSONALIZADO 200 ML"], input[value="PERSONNALISER 200 ML"], input[value="PERSONALIZZA 200 ML"], input[value="DOSTOSUJ 50 ML"], input[value="DOSTOSUJ 100 ML"]'
  );

  // Función para verificar dinámicamente si alguna variante personalizada está seleccionada
  function isPersonalizedVariantSelected() {
    const personalizedInputs = document.querySelectorAll(
      'input[value="PERSONALIZADO"]:checked, input[value="PERSONNALISER"]:checked, input[value="PERSONALIZZA"]:checked, input[value="PERSONALIZADO 50 ML"]:checked, input[value="PERSONNALISER 50 ML"]:checked, input[value="PERSONALIZZA 50 ML"]:checked, input[value="PERSONALIZADO 100 ML"]:checked, input[value="PERSONNALISER 100 ML"]:checked, input[value="PERSONALIZZA 100 ML"]:checked, input[value="PERSONALIZADO 200 ML"]:checked, input[value="PERSONNALISER 200 ML"]:checked, input[value="PERSONALIZZA 200 ML"]:checked, input[value="DOSTOSUJ 50 ML"]:checked, input[value="DOSTOSUJ 100 ML"]:checked'
    );
    return personalizedInputs.length > 0;
  }

  // Tags que definen el modo de validación (mínimo de opciones requeridas) del producto
  const MIKADO_TAGS = [
    'Mikado Regular - Producto Personalizado',
    'Mikado Les Secrets - Producto Personalizado'
  ];
  const PERFUME_TAGS = [
    'Regular - Producto Personalizado',
    'Les Secrets - Producto Personalizado'
  ];
  const ARABICO_TAG = 'Regular Arabico - Personalizado';

  function hasProductTag(tagName) {
    const tags = window.pers_product?.tags;
    if (!Array.isArray(tags)) return false;
    const normalizedTarget = tagName.trim().toLowerCase();
    return tags.some(tag => String(tag).trim().toLowerCase() === normalizedTarget);
  }

  // 'mikado' → mínimo 1 opción (cap o container) | 'perfume' → mínimo 2 (cap y container) | null → sin tag reconocida
  function getValidationMode() {
    if (MIKADO_TAGS.some(hasProductTag)) return 'mikado';
    if (PERFUME_TAGS.some(hasProductTag)) return 'perfume';
    return null;
  }

  if (!inputPersonalizado) return;
  document.addEventListener("avisOptionsLoaded", function () {
    addListeners();
    if (isPersonalizedVariantSelected()) {
      getSelectedValues();
      generateCustomImage();
      preloadImages();
      setTimeout(() => {
        updateProductPriceWithOptions();
        updateMikadoValidation();
      }, 200);
    }
  });

  const productForm = document.querySelector("form");
  if (!productForm) return;

  if (window.pers_product) createInfoBlock();

  document.querySelectorAll('.product-variant__input').forEach(input => {
    input.addEventListener("change", () => {
      clearTimeout(variantChangeDebounceTimer);
      variantChangeDebounceTimer = setTimeout(() => {
        getSelectedValues();
        if (isPersonalizedVariantSelected()) {
          generateCustomImage();
          updateProductPriceWithOptions();
        } else {
          clearCustomImages();
          restoreOriginalPrice();
        }
        updateMikadoValidation();
      }, 500);
    });
  });

  function createInfoBlock() {
    if (!window.pers_product) return;

    // No crear el bloque para productos Mikados
    if (getValidationMode() === 'mikado') return;

    let infoBlock = document.querySelector("#custom-info-block");
    if (!infoBlock) {
      infoBlock = document.createElement("div");

      const hasFragranceFamily = Boolean(window.pers_product?.fragance_family_complete);
      infoBlock.id = "custom-info-block";
      infoBlock.className = `custom-info-block ${!hasFragranceFamily ? 'one-item' : ''}`;
      infoBlock.innerHTML = `
        <div class="custom-info-content">
          <div>${window.pers_product.title.replace(/^(\d+)\s/, "$1<br>")}</div>
          ${hasFragranceFamily ? `<div>${window.pers_product.fragance_family_complete}</div>` : ""}
        </div>`;

      document.body.appendChild(infoBlock);
    }
  }

  function showInfoBlock() {
    // No mostrar el bloque para productos Mikados
    if (getValidationMode() === 'mikado') return;

    const infoBlock = document.querySelector("#custom-info-block");
    const customImageContainer = document.querySelector(".custom-image");
    if (infoBlock && customImageContainer) {
      customImageContainer.appendChild(infoBlock);
      infoBlock.style.display = "flex";
    }
  }

  function hideInfoBlock() {
    const infoBlock = document.querySelector("#custom-info-block");
    if (infoBlock) {
      document.querySelectorAll("body > #custom-info-block").forEach(el => el.remove());
      
      infoBlock.style.display = "none";
      document.body.appendChild(infoBlock);
    }
  }

  function addListeners() {
    const isMikadoProduct = getValidationMode() === 'mikado';
    const formRoot = document.querySelector('product-page product-form')
                  || document.querySelector('#avpoptions-container__v2');
    if (!formRoot) {
      return;
    }

    formRoot.addEventListener('mousedown', function(e) {
      const wrapper = e.target.closest('.avp-productoptionswatchwrapper');
      const input = wrapper?.querySelector('input[type="radio"]');
      if (!input) return;
      input.dataset.apoSelected = input.checked ? 'true' : 'false';
    });

    formRoot.addEventListener('click', function(e) {
      const wrapper = e.target.closest('.avp-productoptionswatchwrapper');
      const input = wrapper?.querySelector('input[type="radio"]');
      if (!input) return;
      if (!isPersonalizedVariantSelected()) return;

      if (isMikadoProduct && input.dataset.apoSelected === 'true') {
        input.checked = false;
      }
      input.dataset.apoSelected = 'false';

      getSelectedValues();

      if (!selectedCap && !selectedContainer) {
        clearCustomImages();
        updatePriceWithoutOptions();
      } else {
        generateCustomImage();
        updateProductPriceWithOptions();
      }
      updateMikadoValidation();

      if (!hasPreloadedImages) {
        hasPreloadedImages = true;
        preloadImages();
      }
    });
  }

  function getSelectedValues() {
    selectedCap = getSelectedValue(capOptions);
    selectedContainer = getSelectedValue(containerOptions);
  }

  function getSelectedValue(names) {
    for (let name of names) {
      const candidates = document.querySelectorAll(
        `.avp-option.ap-options__swatch-container input[type="radio"]:is([field-name="${name}"], [field-name^="${name} "])`
      );
      const selectedInput = Array.from(candidates).find(i => i.checked && !i.disabled);
      if (selectedInput) {
        return selectedInput.value.trim().toLowerCase().replace(/\s+/g, "-");
      }
    }
    return "";
  }

  // Función para obtener el precio total de las opciones seleccionadas
  function getSelectedOptionsPrice() {
    if (!isPersonalizedVariantSelected()) {
      return 0;
    }

    // Buscar todos los inputs de opciones seleccionados que tengan data-variant-price
    const selectedOptionInputs = document.querySelectorAll(
      '.avp-productoptionswatchwrapper input[type="radio"]:checked[data-variant-price]'
    );

    let totalOptionsPrice = 0;
    selectedOptionInputs.forEach(input => {
      const price = parseInt(input.getAttribute('data-variant-price')) || 0;
      totalOptionsPrice += price;
    });

    return totalOptionsPrice;
  }

  // Función para obtener el precio base del producto
  function getBaseProductPrice() {
    const productVariants = document.querySelector('product-variants[data-main-product-variants]');
    if (productVariants && productVariants.currentVariant) {
      return productVariants.currentVariant.price || 0;
    }
    return 0;
  }

  // Función para actualizar el precio del producto sumando las opciones
  function updateProductPriceWithOptions() {
    if (!isPersonalizedVariantSelected()) {
      restoreOriginalPrice();
      return;
    }

    const basePrice = getBaseProductPrice();
    const optionsPrice = getSelectedOptionsPrice();
    const totalPrice = basePrice + optionsPrice;

    // Actualizar el precio mostrado
    const productVariants = document.querySelector('product-variants[data-main-product-variants]');
    if (productVariants && productVariants._formatMoney) {
      const priceOriginal = document.querySelector('[data-js-product-price-extended] [data-js-product-price-original]') ||
                           document.querySelector('[data-js-product-price-compact] [data-js-product-price-original]') ||
                           document.querySelector('[data-js-product-price-original]');
      
      if (priceOriginal) {
        const formattedPrice = productVariants._formatMoney(totalPrice, KROWN.settings.shop_money_format);
        priceOriginal.innerHTML = formattedPrice;
      }

      // Actualizar también el precio en el sticky add to cart si existe
      const stickyPrice = document.querySelector('.sticky-add-to-cart__price-original');
      if (stickyPrice) {
        stickyPrice.textContent = productVariants._formatMoney(totalPrice, KROWN.settings.shop_money_format);
      }
    }
  }
  
  // Función para actualizar precio cuando solo está seleccionada la variante base sin opciones
  function updatePriceWithoutOptions() {
    if (!isPersonalizedVariantSelected()) {
      restoreOriginalPrice();
      return;
    }

    const basePrice = getBaseProductPrice();

    // Actualizar el precio mostrado (solo precio base, sin opciones)
    const productVariants = document.querySelector('product-variants[data-main-product-variants]');
    if (productVariants && productVariants._formatMoney) {
      const priceOriginal = document.querySelector('[data-js-product-price-extended] [data-js-product-price-original]') ||
                           document.querySelector('[data-js-product-price-compact] [data-js-product-price-original]') ||
                           document.querySelector('[data-js-product-price-original]');
      
      if (priceOriginal) {
        const formattedPrice = productVariants._formatMoney(basePrice, KROWN.settings.shop_money_format);
        priceOriginal.innerHTML = formattedPrice;
      }

      // Actualizar también el precio en el sticky add to cart si existe
      const stickyPrice = document.querySelector('.sticky-add-to-cart__price-original');
      if (stickyPrice) {
        stickyPrice.textContent = productVariants._formatMoney(basePrice, KROWN.settings.shop_money_format);
      }
    }
  }

  function updateMikadoValidation() {
    const warningId = 'wim-mikado-warning';
    const addToCartBtns = document.querySelectorAll('button[name="add"].add-to-cart');
    const mode = getValidationMode();

    let shouldBlock = false;
    let warningText = '';

    if (mode && isPersonalizedVariantSelected()) {
      if (mode === 'mikado') {
        // Mikado: se requiere al menos 1 opción (embellecedor O varilla)
        shouldBlock = !selectedCap && !selectedContainer;
        warningText = window.wim?.translates?.mikado_warning || '';
      } else {
        // Perfume: se requieren las 2 opciones (tapón Y envase)
        shouldBlock = !selectedCap || !selectedContainer;
        warningText = window.wim?.translates?.perfume_warning || '';
      }
    }

    let warning = document.getElementById(warningId);

    if (shouldBlock) {
      if (!warning) {
        warning = document.createElement('div');
        warning.id = warningId;
        warning.className = 'wim-mikado-warning';
        document.querySelector('#avpoptions-container__v2')?.insertAdjacentElement('beforebegin', warning);
      }
      warning.textContent = warningText;
      addToCartBtns.forEach(btn => btn.classList.add('wim-avis-custom-disabled'));
      if (mode === 'mikado') clearCustomImages();
    } else {
      warning?.remove();
      addToCartBtns.forEach(btn => btn.classList.remove('wim-avis-custom-disabled'));
    }
  }

  // Función para restaurar el precio original
  function restoreOriginalPrice() {
    const productVariants = document.querySelector('product-variants[data-main-product-variants]');
    if (productVariants) {
      // Si hay una variante actual, usar updatePrice del componente
      if (productVariants.currentVariant) {
        productVariants.updatePrice();
      } else {
        // Si no hay variante, obtener el precio base y mostrarlo
        const basePrice = getBaseProductPrice();
        if (productVariants._formatMoney && basePrice > 0) {
          const priceOriginal = document.querySelector('[data-js-product-price-extended] [data-js-product-price-original]') ||
                               document.querySelector('[data-js-product-price-compact] [data-js-product-price-original]') ||
                               document.querySelector('[data-js-product-price-original]');
          
          if (priceOriginal) {
            const formattedPrice = productVariants._formatMoney(basePrice, KROWN.settings.shop_money_format);
            priceOriginal.innerHTML = formattedPrice;
          }

          // Actualizar también el precio en el sticky add to cart si existe
          const stickyPrice = document.querySelector('.sticky-add-to-cart__price-original');
          if (stickyPrice) {
            stickyPrice.textContent = productVariants._formatMoney(basePrice, KROWN.settings.shop_money_format);
          }
        }
      }
    }
  }

  // Los productos con tag "Regular Arabico - Personalizado" usan prefijo "pers_arabico_" en la imagen
  function getProductImagePrefix() {
    return hasProductTag(ARABICO_TAG) ? "pers_arabico_" : "pers_";
  }

  function getProductImageSuffix() {
    if (!window.pers_product) return "";

    // Verificar que el producto tenga la opción PERSONALIZADO seleccionada
    if (!isPersonalizedVariantSelected()) return "";

    // Los productos con tag "Mikado Les Secrets - Producto Personalizado" usan sufijo "_ls" en la imagen
    return hasProductTag('Mikado Les Secrets - Producto Personalizado') ? "_ls" : "";
  }

  // Perfume necesita cap Y container; Mikado (o sin tag reconocida) le basta con uno de los dos
  function hasRequiredOptionsForImage() {
    if (getValidationMode() === 'perfume') return Boolean(selectedCap && selectedContainer);
    return Boolean(selectedCap || selectedContainer);
  }

  function generateCustomImage() {
    if (!hasRequiredOptionsForImage() || !isPersonalizedVariantSelected()) {
      clearCustomImages();
      return;
    }
    clearTimeout(imageDebounceTimer);
    imageDebounceTimer = setTimeout(_doGenerateCustomImage, 300);
  }

  function _doGenerateCustomImage() {
    if (!hasRequiredOptionsForImage() || !isPersonalizedVariantSelected()) {
      clearCustomImages();
      return;
    }

    let imageName = getProductImagePrefix();

    if (selectedCap && selectedContainer) {
      const cleanCap = selectedCap.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
      const cleanContainer = selectedContainer.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
      imageName += `${cleanCap}-${cleanContainer}`;
    } else if (selectedCap) {
      const cleanCap = selectedCap.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
      imageName += cleanCap;
    } else if (selectedContainer) {
      const cleanContainer = selectedContainer.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
      imageName += cleanContainer;
    }

    const productSuffix = getProductImageSuffix();
    if (productSuffix) {
      imageName += productSuffix;
    }

    const imageUrl = `https://${window.location.hostname}/cdn/shop/files/${imageName}.png?v=1`;
    const generation = ++imageGeneration;
    verifyImage(imageUrl).then(existe => {
      if (generation !== imageGeneration) {
        return;
      }
      if (existe) {
        insertImageInSlider(imageUrl);
      } else {
        clearCustomImages();
        hideInfoBlock();
      }
    });
  }

  function verifyImage(url) {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }

  function insertImageInSlider(imageUrl) {
    if (!document.querySelector("product-page .product-gallery .grid")) return;

    const firstMedia = document.querySelector("product-page .product-gallery .grid").querySelector(".product-gallery-item");
    if (!firstMedia) return;

    const newMedia = firstMedia.cloneNode(true);
    newMedia.id = "FeaturedMedia-custom-image";
    newMedia.dataset.image = imageUrl;
    newMedia.setAttribute("data-index", 0);
    newMedia.setAttribute("data-image", imageUrl);
    newMedia.classList.add("custom-image");

    const zoomElement = newMedia.querySelector("product-image-zoom[data-image]");
    if (zoomElement) {
       zoomElement.remove();
    }

    const imgElement = newMedia.querySelector("img");
    if (imgElement) {
      imgElement.src = imageUrl;
      imgElement.srcset = `${imageUrl} 1080w`;
      imgElement.onload = () => {
        showInfoBlock();
      };
    }

    clearCustomImages();
    const wasEnabled = document.querySelector("product-page css-slider")?.classList.contains("enabled");

    wasEnabled && document.querySelector("product-page css-slider")?.destroySlider();

    const grid = document.querySelector("product-page .product-gallery .grid");
    grid.insertBefore(newMedia, grid.firstChild);
    grid.classList.add("has-custom-image");

    wasEnabled && document.querySelector("product-page css-slider")?.initSlider();
  }

  function clearCustomImages() {
    clearTimeout(imageDebounceTimer);
    imageGeneration++;
    hideInfoBlock();
    const wasEnabled = document.querySelector("product-page css-slider")?.classList.contains("enabled");
    wasEnabled  && document.querySelector("product-page css-slider")?.destroySlider();
    document.querySelectorAll(".custom-image").forEach(image => image.remove());
    document.querySelector("product-page .product-gallery .grid")?.classList.remove("has-custom-image");
    wasEnabled && document.querySelector("product-page css-slider")?.initSlider();
  }

  function showLoader() {
    // Función deshabilitada - no mostrar loader
    return;
  }

  function hideLoader() {
    // Función deshabilitada - no mostrar loader
    const infoBlock = document.querySelector("#custom-info-block");
    if (infoBlock) infoBlock.style.display = "block";
  }

  function preloadImages() {
    const caps = getOptionValues(capOptions);
    const containers = getOptionValues(containerOptions);
    const productSuffix = getProductImageSuffix();
    const imageUrls = [];
    caps.forEach(cap => {
      const cleanCap = cap.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
      containers.forEach(container => {
        const cleanContainer = container.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();

        const url = `https://${window.location.hostname}/cdn/shop/files/${getProductImagePrefix()}${cleanCap}-${cleanContainer}${productSuffix}.png?v=1`;
        imageUrls.push(url);
      });
    });

    preloadImagesGradually(imageUrls);
  }

  function preloadImagesGradually(imageUrls) {
    let index = 0;
    function loadNextImage() {
      if (index >= imageUrls.length) return;

      const img = new Image();
      img.src = imageUrls[index];
      img.onload = img.onerror = () => {
        index++;
        if ("requestIdleCallback" in window) {
          requestIdleCallback(loadNextImage);
        } else {
          setTimeout(loadNextImage, 100);
        }
      };
    }

    loadNextImage();
  }

  function getOptionValues(names) {
      let values = [];
      for (let name of names) {
        const elements = document.querySelectorAll(`.avp-option.ap-options__swatch-container input[type="radio"][name="${name}"]`);
        

        values = values.concat(
            Array.from(elements)
                .map(input => input.value.trim().toLowerCase().replace(/\s+/g, "-"))
        );
      }

      return values;
  }

  // Funcionalidad para mostrar/ocultar sección de tamaños cuando se selecciona "PERSONAL"
  function initPersonalToggle() {
    const personalTriggers = document.querySelectorAll('[data-wim-personal-trigger]');
    
    personalTriggers.forEach(trigger => {
      trigger.addEventListener('change', function() {
        const sectionId = this.getAttribute('data-section-id');
        const sizeSelector = document.querySelector('[data-wim-size-selector]');
        
        if (this.checked) {
          // Mostrar la sección de tamaños
          if (sizeSelector) {
            sizeSelector.style.display = 'block';
            // Inicializar los botones falsos después de mostrarlos
            setTimeout(() => {
              initFakeSizeButtons();
              // Seleccionar automáticamente la primera opción de tamaño
              const firstSizeOption = sizeSelector.querySelector('.wim-fake-size-trigger');
              if (firstSizeOption) {
                firstSizeOption.checked = true;
                // Disparar el evento change para activar la variante real
                firstSizeOption.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }, 100);
          }
          // Mantener "PERSONAL" seleccionado (no deseleccionar)
        }
      });
    });
  }

  // Función para ocultar sección de tamaños cuando se selecciona una variante normal
  function initVariantHiding() {
    const normalVariants = document.querySelectorAll('.product-variant__input:not([data-wim-personal-trigger]):not(.wim-fake-size-trigger):not([data-wim-real-variant])');
    
    normalVariants.forEach(variant => {
      variant.addEventListener('change', function() {
        // Ocultar la sección de tamaños cuando se selecciona una variante normal
        if (this.checked) {
          const sizeSelector = document.querySelector('[data-wim-size-selector]');
          if (sizeSelector) {
            sizeSelector.style.display = 'none';
            // Deseleccionar variantes de tamaño fake
            const sizeInputs = sizeSelector.querySelectorAll('.wim-fake-size-trigger');
            sizeInputs.forEach(input => input.checked = false);
          }
          
          // Deseleccionar el botón "PERSONAL"
          const personalTrigger = document.querySelector('[data-wim-personal-trigger]');
          if (personalTrigger) {
            personalTrigger.checked = false;
          }
        }
      });
    });
  }

  // Función para manejar clicks en botones falsos de tamaño
  function initFakeSizeButtons() {
    const fakeSizeButtons = document.querySelectorAll('.wim-fake-size-trigger:not([data-listener-added])');
    
    fakeSizeButtons.forEach(button => {
      // Marcar que ya tiene listener para evitar duplicados
      button.setAttribute('data-listener-added', 'true');
      
      button.addEventListener('change', function() {
        if (this.checked) {
          const size = this.getAttribute('data-wim-fake-size');
          
          // Buscar la variante real correspondiente y hacer click en ella
          const realVariant = document.querySelector(`[data-wim-real-variant][data-size="${size}"]`);
          
          if (realVariant) {
            realVariant.checked = true;
            // Disparar el evento change para que se procese correctamente
            realVariant.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  // Función para detectar si hay una variante personalizada seleccionada al cargar
  function checkInitialPersonalizedState() {
    // Buscar si hay alguna variante real personalizada ya seleccionada
    const selectedRealVariant = document.querySelector('[data-wim-real-variant]:checked');
    
    if (selectedRealVariant) {
      const size = selectedRealVariant.getAttribute('data-size');
      
      // Activar el botón falso "PERSONALIZADO"
      const personalTrigger = document.querySelector('[data-wim-personal-trigger]');
      if (personalTrigger) {
        personalTrigger.checked = true;
      }
      
      // Mostrar la sección de tamaños
      const sizeSelector = document.querySelector('[data-wim-size-selector]');
      if (sizeSelector) {
        sizeSelector.style.display = 'block';
        
        // Inicializar botones falsos
        setTimeout(() => {
          initFakeSizeButtons();
          
          // Seleccionar el botón de tamaño correspondiente
          const correspondingFakeButton = document.querySelector(`[data-wim-fake-size="${size}"]`);
          if (correspondingFakeButton) {
            correspondingFakeButton.checked = true;
          }
        }, 100);
      }
    }
  }

  // Inicializar la funcionalidad
  initPersonalToggle();
  initVariantHiding();
  
  // Intentar inicializar botones falsos al cargar, y también cuando se muestren
  setTimeout(() => {
    initFakeSizeButtons();
    // Verificar estado inicial después de que todo esté cargado
    checkInitialPersonalizedState();
  }, 500);
});

document.addEventListener('submit', function (event) {
  const form = event.target;

  if (!form.matches('form[action="/cart/add"]')) return;

  if (!validateWimOptions(form)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
}, true);


document.addEventListener('change', function (event) {
  const select = event.target.closest('.wim-opciones');

  if (!select) return;

  updateWimOptionSku(select);
  updateWimSelects(select);
});

function updateWimOptionSku(select) {
  const skuInput = select.parentElement.querySelector('.wim-opciones-sku');

  if (!skuInput) return;

  const selectedOption = select.selectedOptions[0];

  skuInput.value = selectedOption ? (selectedOption.dataset.sku || '') : '';
}

function openPerfumist() {
  const selectors = [
    '.menu-promotion[perfumist]',
    '.button[perfumist]'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      el.style.cursor = 'pointer';
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        let panel = document.querySelector('.pfm-floating-panel-pfo') || document.querySelector('.pfm-bottom-panel');

        if (panel) {
          if (panel.classList.contains('closed')) {
            document.getElementById('pfo-widget-open')?.click();
          } else if (panel.classList.contains('opened')) {
            document.getElementById('pfo-widget-close')?.click();
          }
        }
      });
    });
  });
}

function openNativeSearch() {
  const selectors = [
    '.menu-promotion[native-search]',
    '.button[native-search]'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      el.style.cursor = 'pointer';
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector('main-header a.area--search[data-js-open-search-drawer]')?.click();
      });
    });
  });
}

function initFooterPopup() {
  document
    .querySelectorAll('.footer-item__content p:not(:has(a))')
    .forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const popup = document.querySelector('.wb-modal-overlay');

        if (!popup) return;

        popup.classList.add('wb-active');
      });
    });
}

function validateWimOptions(form) {
  const selects = form.querySelectorAll('.wim-opciones');

  if (!selects.length) return true;

  let valido = true;

  selects.forEach(select => {
    if (!select.value) {
      valido = false;
      select.classList.add('wim-invalid');
    } else {
      select.classList.remove('wim-invalid');
    }
  });

  if (!valido) {
    const primerInvalido = form.querySelector('.wim-opciones.wim-invalid');

    if (primerInvalido) {
      primerInvalido.focus();
      primerInvalido.reportValidity();
    }
  }

  return valido;
}


function updateWimSelects(select) {
  const selects = [...document.querySelectorAll('.wim-opciones')];
  const currentIndex = selects.indexOf(select);

  // Solo afecta a los selects posteriores
  selects.slice(currentIndex + 1).forEach(nextSelect => {

    // Obtener todos los valores seleccionados anteriormente
    const selectedValues = selects
      .slice(0, selects.indexOf(nextSelect))
      .map(select => select.value)
      .filter(value => value !== '');

    nextSelect.querySelectorAll('option').forEach(option => {
      option.disabled = selectedValues.includes(option.value);
    });

    // Si la opción actualmente seleccionada quedó disabled,
    // la deseleccionamos
    if (selectedValues.includes(nextSelect.value)) {
      nextSelect.value = '';
      updateWimOptionSku(nextSelect);
    }
  });
}